import React from "react";

const Map = () => {
  return (
    <div className="w-full h-[300px] mt-6">
      <iframe
        title="Nohmi Bosai India Pvt Ltd Map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.222589560047!2d77.10141237657076!3d28.433678782501177!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1fce9ef8c2f9%3A0x9fe1631e9db20ecb!2sNohmi%20Bosai%20India%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1727029999999!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default Map;
